import React from 'react';
import Hero from '../components/Hero';
import IntroSection from '../components/IntroSection';
import ServicesGrid from '../components/ServicesGrid';
import { LogosStrip, CTABanner, IndustriesSection } from '../components/Sections';
import { ProcessTabs, TechStackTabs } from '../components/ProcessAndTech';
import { Testimonials, FAQ, ContactForm } from '../components/Bottom';

const Home = () => (
  <>
    <Hero />
    <IntroSection />
    <ServicesGrid />
    <LogosStrip />
    <CTABanner text="Ready to Build Your Next Big SaaS Product with AI at its Core?" cta="Let's Talk AI" />
    <IndustriesSection />
    <ProcessTabs />
    <CTABanner text="Empower Your Business with the Latest Technology to Stay Ahead" />
    <TechStackTabs />
    <Testimonials />
    <FAQ />
    <ContactForm />
  </>
);

export default Home;
